<template>
  <div id="change-profile-pic">
    <!-- Premium Header -->
    <div class="header-section">
      <div class="header-gradient">
        <v-row align="center" justify="space-between" class="pa-6">
          <v-col cols="12" md="8">
            <div class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40" color="white">mdi-camera-enhance</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="header-title white--text mb-1">{{ pageTitle }}</h2>
                <p class="header-subtitle white--text mb-0">
                  Upload a professional photo that represents you
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn icon dark large @click="closePrompt" class="close-btn">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card class="form-card">
      <v-form ref="form1" v-model="valid1" lazy-validation v-on:submit.prevent="submitForm">
        <v-card-text>
          <div class="d-flex justify-content-center mb-6" v-if="SearchFlag">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
          </div>

          <!-- Notes Card -->
          <v-card class="notes-card mb-6" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex align-start gap-3">
                <v-icon class="notes-icon mt-1">mdi-information-outline</v-icon>
                <div class="flex-grow-1">
                  <h6 class="notes-title mb-3">Guidelines for Profile Picture</h6>
                  <ul class="notes-list">
                    <li>Only JPG format images are accepted</li>
                    <li>Upload your image from head to chest only</li>
                    <li>Ensure professional attire in the photograph</li>
                    <li>This photo will be visible across all JCI India platforms</li>
                    <li>NHQ reserves the right to block inappropriate photos</li>
                  </ul>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- Image Editor Section -->
          <v-card class="editor-card mb-6" elevation="0">
            <v-card-title class="section-title">
              <v-icon class="mr-2">mdi-image-edit</v-icon>
              Image Editor
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-6">
              <v-row>
                <v-col md="8" cols="12">
                  <div class="cropper-container">
                    <cropper ref="cropper" :src="MemberImage.ImageUrl" :stencil-props="{
                      handlers: {},
                      movable: false,
                      scalable: false,
                      aspectRatio: 1,
                      previewClass: 'preview',
                    }" :stencil-size="{
                      width: 200,
                      height: 200,
                    }" image-restriction="stencil" />
                  </div>
                </v-col>
                <v-col md="4" cols="12">
                  <!-- File Input -->
                  <div class="mb-4">
                    <v-file-input :clearable="false" truncate-length="15" accept="image/jpeg"
                      placeholder="Select JPG Image" v-model="UploadImage1" prepend-icon="mdi-cloud-upload"
                      @change="addImage(1)" outlined dense class="upload-input">
                      <template v-slot:append-outer>
                        <v-icon v-if="UploadImage1" color="error" @click="deleteImage(1)" class="cursor-pointer"
                          title="Clear selection">
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-file-input>
                  </div>

                  <!-- Action Buttons -->
                  <div class="edit-actions mb-4">
                    <h6 class="mb-3">Image Adjustments</h6>
                    <div class="action-grid">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small color="primary" class="action-fab" @click.prevent="flip(true, false)"
                            v-bind="attrs" v-on="on">
                            <v-icon>mdi-swap-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <span>Flip Horizontal</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small color="primary" class="action-fab" @click.prevent="flip(false, true)"
                            v-bind="attrs" v-on="on">
                            <v-icon>mdi-swap-vertical</v-icon>
                          </v-btn>
                        </template>
                        <span>Flip Vertical</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small color="success" class="action-fab" @click.prevent="rotate(90)" v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-rotate-right</v-icon>
                          </v-btn>
                        </template>
                        <span>Rotate Right (90°)</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small color="warning" class="action-fab" @click.prevent="rotate(-90)"
                            v-bind="attrs" v-on="on">
                            <v-icon>mdi-rotate-left</v-icon>
                          </v-btn>
                        </template>
                        <span>Rotate Left (90°)</span>
                      </v-tooltip>
                    </div>
                  </div>

                  <!-- Submit Button -->
                  <v-btn @click.prevent="submitForm" :loading="SubmitFlag" block large color="primary"
                    class="upload-btn white--text font-weight-bold">
                    <v-icon left>mdi-check-circle</v-icon>
                    Upload Image
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    currentPhoto: {
      type: String,
    },
    pageId: {
      //   required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      pageTitle: "Upload Profile Picture",
      pageDescription: "",

      pageContent: "",

      rows: [],

      image: {
        src: "media/images/white-user.png",
        type: null,
      },

      newimage: "",
      selectedImage: "",

      UploadImage1: {},
      MemberImage: { src: null },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // this.initialize();
  },
  created() {
    this.MemberImage.src = this.currentPhoto;
  },
  methods: {
    initialize() {
      console.log("initialize called");
      var options = this.cropImageOptions;
      console.log("options=" + JSON.stringify(options));
      // this.$refs.cropper.setDefaults(options);
      this.$refs.cropper.setAspectRatio(options.aspectRatio);
      // this.$refs.cropper.setCropBoxData(this.cropBoxData);
      this.$refs.cropper.setDragMode("move");
    },
    addImage(id) {
      console.log("addImage called");
      console.log({ id });
      switch (id) {
        case 1:
          var file = this.UploadImage1;
          console.log({ file });
          var src = URL.createObjectURL(file);
          console.log({ src });
          if (this.MemberImage.src) {
            URL.revokeObjectURL(this.MemberImage.src);
          }
          var FileType = file.type;
          console.log({ FileType });
          this.MemberImage = {
            ImageName: file.name,
            ImageType: FileType,
            ImageUrl: src,
            UploadedImage: file,
          };
          break;

        default:
          break;
      }
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      switch (id) {
        case 1:
          this.MemberImage = {
            ImageName: null,
            ImageType: null,
            ImageUrl: null,
            UploadedImage: null,
          };
          this.UploadImage1 = {};
          break;

        default:
          break;
      }
    },
    crop() {
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob((blob) => {
        // Do something with blob: upload to a server, download and etc.
      }, this.image.type);
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      console.log("loadImage is called");
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flip(x, y) {
      console.log("flip x=" + x + ", y=" + y);
      this.$refs.cropper.flip(x, y);
    },
    rotate(angle) {
      console.log("rotate=" + angle);
      this.$refs.cropper.rotate(angle);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    setImage(e) {
      console.log("setImage called");
      const file = e.target.files[0];
      this.fileExtension = file.name.split(".").pop();
      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          var options = this.cropImageOptions;
          console.log("options=" + JSON.stringify(options));
          this.$refs.cropper.initialize();
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    download() {
      if (this.cropImg) {
        var extention = this.fileExtension;
        var href = this.cropImg;
        var link = document.createElement("a");
        link.addEventListener(
          "click",
          function () {
            link.href = href;
            link.download = "cropper-img." + extention;
            // console.log(link.download);
          },
          false
        );
        link.click();
      } else {
        alert("Please, crop image before download it");
      }
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.newimage);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var pageId = this.pageId;
      console.log("pageId=" + pageId);
      //   this.getMemberDetails();
    },
    submitForm() {
      console.log("submitForm called");
      var message = "";
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        var file = this.UploadImage1;
        var FileType = file.type;
        var ImageName = file.name;
        console.log({ FileType });
        console.log({ ImageName });
        var image = "";
        canvas.toBlob((blob) => {
          image = canvas.toDataURL();
          console.log("image=" + image);
          this.selectedImage = image;
          const formData = new FormData();
          formData.append("ProfilePicture", blob, ImageName);
          this.uploadImage(formData);
          // Perhaps you should add the setting appropriate file format here
          // this.closePrompt();
        }, FileType);
      } else {
        message += "Kindly select image. ";
        this.toast("error", message, true);
      }
    },
    /*
    uploadImage(formData) {
      const token = getCookie("ifragasatt_cookie");
      const url = "https://vem-user.fjardestatsmakten.se/userProfilePic";
      const headers = {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "ifr-jwt-token": token
      };

      axios.post(url, formData, { headers });
    },
    */
    uploadImage(upload) {
      console.log("uploadImage is called");
      /*
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      console.log("coordinates=" + JSON.stringify(coordinates));
      console.log("canvas=" + JSON.stringify(canvas));
      this.coordinates = coordinates;
      this.croppedImage = canvas.toDataURL();
      */
      // var ProfilePicture = this.$refs.input.files[0];
      // var ProfilePicture = this.$refs.cropper.getCroppedCanvas().toDataURL();
      var ProfilePicture = true;
      // console.log("ProfilePicture=" + JSON.stringify(ProfilePicture));

      if (ProfilePicture) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/profile-picture-update";
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        var selectedImage = this.selectedImage;

        // let upload = new FormData();

        // var ProfilePicture = this.$refs.cropper.getCroppedCanvas().toDataURL();

        upload.append("FileId", 1);

        // if (ProfilePicture) {
        // upload.append("ProfilePicture", ProfilePicture);
        // }
        /*
        var upload = {
          member: member,
        };
        */
        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.newimage = selectedImage;
              thisIns.$session.set("ProfilePic", selectedImage);
              thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (ProfilePicture == "") {
          message += "File is not selected";
        }
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Color Palette
$navy: #3A67B1;
$aqua: #0097D7;
$gold: #EDBE38;
$seaform: #56BDA3;
$text-90-black: #414042;
$text-off-black: #0A0F29;
$text-white: #FFFFFF;
$danger: #e74c3c;
$success: #1db954;
$warning: #ffc107;
$info: #2196F3;

$primary-color: $navy;
$secondary-color: $aqua;
$bg-light: #f8fafc;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#change-profile-pic {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 0;

  // ============================================
  // HEADER SECTION
  // ============================================
  .header-section {
    background: linear-gradient(135deg, $navy 0%, $aqua 50%, $navy 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5), 0 0 40px rgba(0, 151, 215, 0.3);
    margin: 15px !important;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: rotate 20s linear infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: fadeInUp 0.8s ease-out;
  }

  .header-subtitle {
    font-size: 14px;
    opacity: 0.95;
    letter-spacing: 0.3px;
    animation: fadeInUp 1s ease-out;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid rgba(255, 255, 255, 0.2);

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: scale(1.1) rotate(90deg);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }
  }

  // ============================================
  // FORM CARD
  // ============================================
  .form-card {
    border-radius: 18px !important;
    border: 2px solid rgba(58, 103, 177, 0.2);
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.15), 0 0 30px rgba(0, 151, 215, 0.08);
    animation: fadeInScale 0.6s ease-out;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 50%, #f5f7ff 100%);
    position: relative;
    overflow: hidden;
    margin: 0 15px 20px 15px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 100% 0%, rgba(0, 151, 215, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  // ============================================
  // NOTES CARD
  // ============================================
  .notes-card {
    border-radius: 14px !important;
    background: linear-gradient(135deg, rgba(33, 150, 243, 0.12) 0%, rgba(119, 235, 255, 0.08) 100%) !important;
    border-left: 5px solid $info !important;
    animation: slideInUp 0.8s ease-out;
    box-shadow: 0 8px 24px rgba(33, 150, 243, 0.15) !important;
    border: 2px solid rgba(33, 150, 243, 0.25) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(33, 150, 243, 0.1) 0%, transparent 70%);
      pointer-events: none;
    }

    .notes-icon {
      color: $info !important;
      font-size: 28px;
      animation: float 3s ease-in-out infinite;
    }

    .notes-title {
      font-size: 16px;
      font-weight: 700;
      color: $info;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      margin: 0;
    }

    .notes-list {
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 13px;
      color: $text-90-black;
      line-height: 1.8;

      li {
        position: relative;
        padding-left: 20px;
        margin-bottom: 8px;

        &::before {
          content: "✓";
          position: absolute;
          left: 0;
          color: $success;
          font-weight: 900;
          font-size: 14px;
        }
      }
    }
  }

  // ============================================
  // EDITOR CARD
  // ============================================
  .editor-card {
    border-radius: 14px !important;
    border: 2px solid $border-color !important;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.1) !important;
    animation: slideInUp 0.8s ease-out 0.1s backwards;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 100%) !important;

    .section-title {
      font-size: 18px;
      font-weight: 700;
      color: $primary-color;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 16px 20px !important;
    }
  }

  // ============================================
  // CROPPER CONTAINER
  // ============================================
  .cropper-container {
    background: linear-gradient(135deg, $bg-light 0%, #ffffff 100%);
    border: 3px dashed $border-color;
    border-radius: 14px;
    padding: 10px;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05);
    animation: fadeInScale 0.7s ease-out;

    .cropper {
      height: 300px !important;
      background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
      border-radius: 10px;
    }
  }

  // ============================================
  // UPLOAD INPUT
  // ============================================
  .upload-input {
    transition: all 0.3s ease;

    &:focus-within {
      box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.1);
    }
  }

  // ============================================
  // EDIT ACTIONS
  // ============================================
  .edit-actions {
    padding: 16px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.08) 0%, rgba(0, 151, 215, 0.08) 100%);
    border-radius: 12px;
    border: 2px solid rgba(58, 103, 177, 0.15);

    h6 {
      font-size: 14px;
      font-weight: 700;
      color: $primary-color;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      margin: 0;
    }

    .action-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      .action-fab {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        font-weight: 700;

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        }
      }
    }
  }

  // ============================================
  // UPLOAD BUTTON
  // ============================================
  .upload-btn {
    background: linear-gradient(135deg, $primary-color 0%, $secondary-color 100%) !important;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25) !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 10px !important;
    text-transform: uppercase;
    letter-spacing: 0.6px;

    &:hover:not(:disabled) {
      transform: translateY(-3px);
      box-shadow: 0 12px 30px rgba(58, 103, 177, 0.35) !important;
    }

    &:disabled {
      opacity: 0.6;
    }
  }

  // ============================================
  // GAP UTILITY
  // ============================================
  .gap-4 {
    gap: 16px;
  }

  .gap-3 {
    gap: 12px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 768px) {
    .header-section {
      margin: 10px !important;
    }

    .form-card {
      margin: 0 10px 20px 10px;
    }

    .header-title {
      font-size: 24px;
    }

    .header-subtitle {
      font-size: 13px;
    }
  }
}
</style>